<app-banner [heading]="'WORKSHOPS & SEMINARS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="features" class="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-6">
            <img src="assets/img/workshop/w13.jpg" class="img-fluid" alt="">
			           
						            
          </div>
          <div class="col-lg-6 pt-5 pt-lg-0">
            <h5>  <br><br> <b>Date:29-09-2021</b><br>At Tagore Global School,KKR First Aid  and CPR Workshop was held on 29th September, 2021.
			The workshop aimed to introduce quick reaction to possible daily life injuries,symptoms, preventions and treatment required.
			This helped  students to recognize and understand common injuries and diseases in daily life as well as seek medical aid and
			treatment when needed.Students were also asked to prepare First Aid Boxes to inculcate sense of safety among them.A demonstration of
			live CPR  done on a student model by Ms Shreya, gave an insight and a first hand experience to students. The session was immensely 
			enjoyed by the students.</h5>
            
			</div>
			<!--<div class="col-lg-6">

			<img src="assets/img/workshop/w13.jpg" class="img-fluid" alt="">
            
			
          </div> -->
		  </div>
		  <div class="row feature-item">
		   <div class="col-lg-6">
		    <img src="assets/img/workshop/w2.jpg" class="img-fluid" alt="">
			</div>
			<div class="col-lg-6 pt-5 pt-lg-0">
			<h5> <br><br> <b> Date: 23-09-21 </b> <br>Tagore Global School,Kurukshetra organised Expert led Online English Workshop by Freadom on 23rd,September, 2021.
			Students from grade Nursery upto grade 6th participated enthusiastically and really had good experience and got 
			e-certicates for the learning.The facilitators enabled students to become confident speakers,creative writers and independent readers.
			The students as well as the parents enjoyed and liked the session as they combined fun with learning and appreciated Educators for such initiatives.
			</h5></div>
			 <div class="col-lg-6">
		  <img src="assets/img/workshop/w4.jpg" class="img-fluid" alt="">
		
		  </div>
		  <div class="col-lg-6">
					<h5> <b> Date : 19-07-21 </b> <br>
		In continuation to the latest initiative initiated by Tagore Global School,
		by adopting International Early Years Teaching Program for Grades Pre Nursery 
		to Grade 2 led by Mrs Sangeeta Dutta,an expert in Early Years Education;in which 
		trans- disciplinary approach of teaching with latest techniques was infused with the curriculum ;
		in the Second Phase,the teachers' training sessions were followed by a number of special direct 
		Teaching Classes of students of TGS. The tiny tots were elated to enjoy the amazing way of 
		learning new concepts with so much fun ,music and dance.They were literally transported to 
		the colorful fairy world of stories and were quick to pick up various new sounds,spellings;
		novel ways of counting, addition  and what not.Parents wholeheartedly welcomed and appreciated the new approach . </h5>
		  </div>
		  	 <!-- <div class="col-lg-6">
				  <img src="assets/img/workshop/w5.jpg" class="img-fluid" alt="">
		</div> -->
        </div>
	
		  <div class="row feature-item">
		   <div class="col-lg-6">
		    <img src="assets/img/workshop/w3.jpg" class="img-fluid" alt="">
			</div>
			<div class="col-lg-6 pt-5 pt-lg-0">

      <h5><b>Date:06-07-21</b><br>Tagore Global School organised a series of Workshops for the Early Years Educators of Grade Pre-Nursery to Grade II, 
		  in continuation to its initiative to infuse Innovative Teaching in Early Years with an International dimension.Mrs Sangeeta Dutta,
		  an Early Years Educator from Oman having a vast experience in her field in Middle East,trained by Harward University,
		  Australian University, Greenwich University,UK ,held the Workshops elaborating the latest, pedagogical practices adopted 
		  in British and American Curriculum and their relevance in Indian context.Practical demo classes were conducted for the teachers 
		  to show how new concept should be introduced in play way method with the help of enactment,stories,music, dance and novel,creative teaching aids.
		  A special Workshop on PHONICS was also conducted.Valuable Resource Material were shared with the teachers. 
		  TGS teachers had a lot to takeaway for their students.In the Second Phase of the series of Training Workshops,
		  Mrs Dutta will be directly taking some Special Online Classes of Early Years children of TGS as well as for their Parents .
		  Principal,Dr Auddy thanked Mrs Dutta for her generous time and contribution in helping our Educators to raise happier and
		  more active and confident children .</h5>
	  </div>

		</div>
	</div></section>
      <!-- End About Section -->
	
	
    
	

	
	
    
    
  </main>